var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_11_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0060AD",
    d: "M89.545,8.221c-1.951-1.952-5.119-1.952-7.07,0L48.01,42.686L13.545,8.221c-1.952-1.951-5.117-1.952-7.071,0 c-1.953,1.953-1.953,5.119,0,7.071l34.465,34.465L6.474,84.222c-1.953,1.952-1.953,5.118,0,7.07 c0.977,0.977,2.256,1.465,3.536,1.465s2.559-0.488,3.536-1.465l76-76C91.498,13.339,91.498,10.173,89.545,8.221z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0060AD",
    d: "M60.982,55.659l-7.07,7.07l28.563,28.563c0.976,0.977,2.256,1.465,3.535,1.465s2.56-0.488,3.535-1.465 c0.977-0.976,1.465-2.256,1.465-3.535s-0.488-2.56-1.465-3.535L60.982,55.659z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.f23d4512d336dee9328392a2f9ceadf2.svg";
export { ForwardRef as ReactComponent };